// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1981":"css/admin-app.6781","4310":"css/app.6781"}[chunkId] + ".css";
};